import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/tools/")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Free Tools for Founders",
      description:
        "Free diagnostic tools from LAA Concierge Consulting, including the funding readiness scorecard.",
      path: "/tools",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title="Tools" intro="[SUPPLY: tools hub copy and tool list]" />;
}
